import { useEffect, useRef, useState } from "react";
import { getPaywallCountdown } from "src/appConfig";
import { useDiscount } from "./useDiscount";

const useDiscountCountdown = (customInterval) => {
  const { setIsDiscounted } = useDiscount();
  const [isTimeUp, setIsTimeUp] = useState(false);
  const firstRender = useRef(true);

  const storedCountdown = getPaywallCountdown();

  if (storedCountdown && firstRender.current) {
    firstRender.current = false;
  }

  const interval = customInterval || 60 * 10 * 1000;

  const [remainingTime, setRemainingTime] = useState(() => {
    const savedEndTime = localStorage.getItem("endTime");
    return savedEndTime ? Math.max(savedEndTime - Date.now(), 0) : interval;
  });

  const storageKey = customInterval ? "upsaleEndTime" : "endTime";

  useEffect(() => {
    if (!localStorage.getItem(storageKey)) {
      localStorage.setItem(storageKey, String(Date.now() + interval));
    }

    const updateRemainingTime = () => {
      const endTime = localStorage.getItem(storageKey);
      const timeLeft = Math.max(endTime - Date.now(), 0);

      if (timeLeft > 0) {
        setRemainingTime(timeLeft);
      } else {
        const newEndTime = Date.now() + interval;
        localStorage.setItem(storageKey, String(newEndTime));
        setRemainingTime(interval);
        setIsTimeUp(false);
        setIsDiscounted(true);
      }
    };

    const timerInterval = setInterval(updateRemainingTime, 1000);

    return () => clearInterval(timerInterval);
  }, [setIsDiscounted, interval, customInterval, storageKey]);

  const minutes = Math.floor(remainingTime / 60000);
  const seconds = Math.floor((remainingTime % 60000) / 1000);
  const displayMinutes = String(minutes).padStart(2, "0");
  const displaySeconds = String(seconds).padStart(2, "0");

  const time = { minutes, seconds, displayMinutes, displaySeconds };

  return { time, isTimeUp };
};

export default useDiscountCountdown;
